import React from "react";
import { connect } from "react-redux";
import KIT from "../../Descargable/Kit de Apoyo E2.zip";
import { dataLayerTag } from "../functions";

class KitDiagnosticoPlanMovilidad extends React.PureComponent {
  render() {
    return (
      <div>
          <div className="row">
            <div className="col-sm-9 text-left">
              <div className="PM-cuadro-3">
                <h5><strong>Descarga el kit de difusión con material digital y físico que te permitirá comunicar y reforzar la invitación a contestar.</strong></h5>
                <p>Una vez logrado el 60% de las respuestas podrás cerrar la encuesta desde la plataforma.</p>
              </div>
            </div>
            <div className="col-sm-3 btn-material">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                onClick={() => {
                  window.open(KIT,'_blank');
                  // gtd -> descarga del kit etapa 2
                  dataLayerTag({
                    'event': 'etapa_2_descarga_kit',
                    'etapa': '2'
                  });
                }}
              >Descargar kit</button>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(KitDiagnosticoPlanMovilidad);
